import PropTypes from "prop-types"
import React from "react"
import PaymentMethodDropdown from "src/main/Billing/PaymentMethodDropdown"

import Form from "src/components/Form"

import {
  CARD_READER_METHOD,
  OFFLINE_METHOD,
  OFFLINE_TENDERS,
  findTender,
} from "./methods"

const PaymentMethodFields = ({
  control,
  register,
  method,
  paymentMethods,
  cardReaders,
  copy,
}) => {
  const tenderField =
    method.kind === OFFLINE_METHOD ? findTender(method.id)?.field : null

  return (
    <div>
      <div className="mb-5 w-full">
        <PaymentMethodDropdown
          name="paymentMethodId"
          onlineMethods={paymentMethods}
          control={control}
          includeExpirationDates
          showCardReader={cardReaders.length > 0}
          label={copy.methods.title}
          cardReaderLabel={copy.methods.cardReader}
          manualLabel={copy.methods.manual}
        />
      </div>
      {method.kind === CARD_READER_METHOD && (
        <div className="mb-5 w-full">
          <Form.Label htmlFor="pay-invoices-card-reader">
            {copy.methods.cardReader}
          </Form.Label>
          <Form.Select
            id="pay-invoices-card-reader"
            {...register("cardReaderId")}
          >
            {cardReaders.map((cardReader) => (
              <option key={cardReader.id} value={cardReader.id}>
                {cardReader.displayName}
              </option>
            ))}
          </Form.Select>
        </div>
      )}
      {method.kind === OFFLINE_METHOD && (
        <div className="mb-5 flex w-full flex-row gap-4">
          <div className="flex w-1/2 flex-col">
            <Form.Label htmlFor="pay-invoices-payment-type">
              {copy.fields.manualPaymentType}
            </Form.Label>
            <Form.Select
              id="pay-invoices-payment-type"
              {...register("paymentType")}
            >
              {OFFLINE_TENDERS.map((tender) => (
                <option key={tender.paymentType} value={tender.paymentType}>
                  {copy.tenders[tender.copyKey]}
                </option>
              ))}
            </Form.Select>
          </div>
          <div className="flex w-1/2 flex-col">
            {tenderField && (
              <>
                <Form.Label htmlFor={`pay-invoices-${tenderField}`}>
                  {copy.fields[tenderField]}
                </Form.Label>
                <Form.TextField
                  id={`pay-invoices-${tenderField}`}
                  {...register(tenderField)}
                />
              </>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

PaymentMethodFields.propTypes = {
  control: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  method: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    id: PropTypes.string,
  }).isRequired,
  paymentMethods: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    })
  ).isRequired,
  cardReaders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      displayName: PropTypes.string,
    })
  ).isRequired,
  copy: PropTypes.shape({
    methods: PropTypes.object.isRequired,
    tenders: PropTypes.object.isRequired,
    fields: PropTypes.object.isRequired,
  }).isRequired,
}

export default PaymentMethodFields
